export const _en = {
    name: {
        label: "Label"
    },
    refTrainingProductId: {
        label: "Training product"
    },
    moduleDate: {
        label: "Module date"
    },
    beginHour: {
        label: "Begin hour"
    },
    duration: {
        label: "Module duration"
    },
    isOffSyllabus: {
        label: "Off syllabus"
    }
};

export const _fr = {
    name: {
        label: "Libellé"
    },
    refTrainingProductId: {
        label: "Modèle de stage"
    },
    moduleDate: {
        label: "Date du module"
    }
    ,
    beginHour: {
        label: "Heure de début"
    },
    duration: {
        label: "Durée du bloc"
    },
    isOffSyllabus: {
        label: "Hors syllabus",
        tooltip: "Une journée hors syllabus ne peut contenir que des activités hors syllabus"
    }

};